module.exports = __webpack_public_path__ + "media/images/logo-trustvox-2cd8bde463f5d82aae0f0cec061d6b8f.png";